import AutoComplete from 'portaltransparencia-common/components/AutoComplete.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  findDespesas,
  findElementos,
  findFontes,
  findFuncoes,
  findOrgaos,
  findProgramas,
  findProjetos,
  findSubfuncoes,
  findUnidades
} from './Actions';

const FILTER_FIELDS = ['codigo', 'descricao'];

const FormFilterProgramatica = ({
  filtros,
  onChange,
  findOrgaos,
  findUnidades,
  findFuncoes,
  findSubfuncoes,
  findProgramas,
  findProjetos,
  findElementos,
  findDespesas,
  findFontes
}) => {
  const f = filtros || Map({});

  const handleChange = event => {
    onChange(event);
    if (event.name === 'orgao' && !event.value) {
      onChange({ name: 'unidade', value: null });
    }
    if (event.name === 'elemento' && !event.value) {
      onChange({ name: 'despesa', value: null });
    }
  };

  const getFiltroAtual = () => {
    const fields = [
      'orgao',
      'unidade',
      'funcao',
      'subFuncao',
      'programa',
      'projeto',
      'elemento'
    ];

    const paramFilter = [];

    fields.forEach(field => {
      const value = f.get(field);
      if (value) {
        paramFilter.push(`${field}=${value.get('codigo')}`);
      }
    });

    return paramFilter.join('&');
  };

  return (
    <div className="panel-inside-panel mt-xs">
      <Panel
        insidePanel
        title="Especificar Programática"
        isTable
        tableResponsive
      >
        <Row>
          <Col xs={12} sm={4} md={4} key={'orgao'}>
            <AutoComplete
              label="Órgão"
              id="orgao"
              name="orgao"
              onLoad={() => findOrgaos()}
              onChange={handleChange}
              value={f.get('orgao')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione o Órgão"
              clearable
              filterFields={FILTER_FIELDS}
              enableCache={false}
            />
          </Col>
          <Col
            xs={12}
            sm={4}
            md={4}
            key={`unidade-${f.getIn(['orgao', 'codigo'])}`}
          >
            <AutoComplete
              label="Unidade"
              id="unidade"
              name="unidade"
              onLoad={() => findUnidades(getFiltroAtual())}
              onChange={onChange}
              value={f.get('unidade')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione a Unidade"
              filterFields={FILTER_FIELDS}
              enableCache={false}
              disabled={!f.get('orgao')}
            />
          </Col>
          <Col xs={12} sm={4} md={4} key={'funcao'}>
            <AutoComplete
              label="Função"
              id="funcao"
              name="funcao"
              onLoad={() => findFuncoes(getFiltroAtual())}
              onChange={onChange}
              value={f.get('funcao')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione a Função"
              filterFields={FILTER_FIELDS}
              enableCache={false}
            />
          </Col>
          <Col xs={12} sm={4} md={4} key={'subFuncao'}>
            <AutoComplete
              label="Subfunção"
              id="subFuncao"
              name="subFuncao"
              onLoad={() => findSubfuncoes(getFiltroAtual())}
              onChange={onChange}
              value={f.get('subFuncao')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione a Subfunção"
              filterFields={FILTER_FIELDS}
              enableCache={false}
            />
          </Col>
          <Col xs={12} sm={4} md={4} key={'programa'}>
            <AutoComplete
              label="Programa"
              id="programa"
              name="programa"
              onLoad={() => findProgramas(getFiltroAtual())}
              onChange={onChange}
              value={f.get('programa')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione o Programa"
              filterFields={FILTER_FIELDS}
              enableCache={false}
            />
          </Col>
          <Col xs={12} sm={4} md={4} key={'projeto'}>
            <AutoComplete
              label="Projeto"
              id="projeto"
              name="projeto"
              onLoad={() => findProjetos(getFiltroAtual())}
              onChange={onChange}
              value={f.get('projeto')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione o Projeto"
              filterFields={FILTER_FIELDS}
              enableCache={false}
            />
          </Col>
          <Col xs={12} sm={4} md={4} key={'elemento'}>
            <AutoComplete
              label="Elemento"
              id="elemento"
              name="elemento"
              onLoad={() => findElementos(getFiltroAtual())}
              onChange={handleChange}
              value={f.get('elemento')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione o Elemento"
              filterFields={FILTER_FIELDS}
              enableCache={false}
            />
          </Col>
          <Col
            xs={12}
            sm={4}
            md={4}
            key={`despesa-${f.getIn(['elemento', 'codigo'])}`}
          >
            <AutoComplete
              label="Despesa"
              id="despesa"
              name="despesa"
              onLoad={() => findDespesas(getFiltroAtual())}
              onChange={onChange}
              value={f.get('despesa')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione a Despesa"
              filterFields={FILTER_FIELDS}
              enableCache={false}
              disabled={!f.get('elemento')}
            />
          </Col>
          <Col xs={12} sm={4} md={4} key={'fonteRecurso'}>
            <AutoComplete
              label="Fonte de Recurso"
              id="fonteRecurso"
              name="fonteRecurso"
              onLoad={() => findFontes(getFiltroAtual())}
              onChange={onChange}
              value={f.get('fonteRecurso')}
              valueKey="codigo"
              labelKey="descricao"
              placeholder="Selecione a Fonte de Recurso"
              filterFields={FILTER_FIELDS}
              enableCache={false}
            />
          </Col>
        </Row>
      </Panel>
    </div>
  );
};

FormFilterProgramatica.propTypes = {
  filtros: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  findOrgaos: PropTypes.func.isRequired,
  findUnidades: PropTypes.func.isRequired,
  findFuncoes: PropTypes.func.isRequired,
  findSubfuncoes: PropTypes.func.isRequired,
  findProgramas: PropTypes.func.isRequired,
  findProjetos: PropTypes.func.isRequired,
  findElementos: PropTypes.func.isRequired,
  findDespesas: PropTypes.func.isRequired,
  findFontes: PropTypes.func.isRequired
};

export { FormFilterProgramatica };

export default connect(null, {
  findOrgaos,
  findUnidades,
  findFuncoes,
  findSubfuncoes,
  findProgramas,
  findProjetos,
  findElementos,
  findDespesas,
  findFontes
})(FormFilterProgramatica);
